import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoginContainer, Title, Header, SubTitle, CallToAction, TroubleLogging } from './Login.style';
import { frontEndUrl, httpOnlySecurityService } from '../../externals/iam';
import { useLocation } from '../../externals/routing';

const Login = () => {
  const intl = useIntl();
  const location = useLocation();
  const fromLocation = location.pathname;
  const afterLoginUrl = fromLocation ? `${frontEndUrl}/#${fromLocation}` : frontEndUrl;

  return (
    <LoginContainer>
      <Header>Advanced Track and Trace</Header>
      <span>
        <Title>Welcome to ATAT</Title>
      </span>
      <span>
        <SubTitle>ATAT provides Track & Trace with drill-down capability, showing the events and messages</SubTitle>
        <SubTitle>associated with Item, Receptacle, Despatch and Consignment IDs.</SubTitle>
      </span>
      <div style={{ display: 'flex', gap: '20px' }}>
        <CallToAction type="button" onClick={() => httpOnlySecurityService.login(afterLoginUrl)}>
          SSO LOGIN
          <FontAwesomeIcon icon={faSignInAlt} />
        </CallToAction>
      </div>
      <TroubleLogging>
        {intl.formatMessage({
          id: 'app.login.troubleLogging',
        })}
        &nbsp;
        <a style={{ textDecoration: 'underline' }} href="mailto:servicedesk@ipc.be">
          servicedesk@ipc.be
        </a>
        &nbsp; or &nbsp;
        <a style={{ textDecoration: 'underline' }} href="https://servicedesk.ipc.be/servicedesk">
          IPC Customer Service Desk Portal
        </a>
      </TroubleLogging>
    </LoginContainer>
  );
};

export default Login;
